import { i18n } from "@lingui/core";
import { Trans, t } from '@lingui/macro';
import React from 'react';
import { Link } from "react-router-dom";
import * as yup from "yup";
import { useYupValidationForm } from "../../common/hooks/useYupValidationForm";
import { forgotPassword } from "../../util/APIUtils";
import { error, success } from "../../util/toast";
import AuthLayout from "../layout";
const validationSchema = yup.object({
  email: yup.string().email(`Không đúng định dạng`)
});

const ForgotPassWord = () => {
  const { register, handleSubmit, formState: { errors } } = useYupValidationForm(validationSchema);
  const [loading, setLoading] = React.useState(false);

  const onSubmit = data => {
    setLoading(true);
    const reqData = data.email
    forgotPassword(reqData)
      .then(rs => {
        if (rs.ok) {
          success(i18n._(t`Vui lòng kiểm tra lại email để đặt lại mật khẩu`))
        }else {
          error(i18n._(t`Vui lòng kiểm tra lại email`))
        }
        setLoading(false);
      }).catch(err => {
        console.log(err)
        setLoading(false);
        error((err && err.detail) || i18n._(t`Oops, có lỗi xảy ra, vui lòng thử lại sau`))
      });
  };

  return (
    <AuthLayout>
      <div className="bg-overlay_color p-[20px]">
        <div className={'my-[10px] mx-auto md:my-[10px] lg:my-[15px] text-center'}>
          <h1 className={'text-luat_HN_primary font-bold text-4xl'}>
            <Trans>Quên mật khẩu</Trans>
          </h1>
        </div>
        <form className={'flex flex-col w-96'} onSubmit={handleSubmit(onSubmit)}>
          <div className={'mx-10 py-1 lg:py-3 text-white'}>
            <div className={`font-bold mr-2 mt-1`}>
              <Trans>Email</Trans>
            </div>
            <input
              className={`w-full text-black py-2 px-5 rounded-xl focus:ring outline-none border-2 ${errors.email ? 'border-red-500' : 'border-gray-300'
                }`}
              placeholder={t`Nhập địa chỉ email chính của bạn`}
              {...register('email')}
            />
            <div
              className={`text-right text-red-500 font-bold mr-2 mt-1 text-sm`}
            >
              {errors.email?.message ? (
                i18n._(t`${errors.email.message}`)
              ) : (
                <>&nbsp;</>
              )}
            </div>
          </div>
          <div className={' w-full px-12'}>
            <button
              disabled={loading}
              className={'text-white bg-luat_HN_primary hover:bg-luat_HN_primary_hover py-2 w-full rounded-lg flex items-center justify-center gap-1'}
              type={'submit'}
            >
              {loading && <div className="loading w-8 h-8"/>}
              <Trans>Gửi</Trans>
            </button>
          </div>
          <div className={`md:my-5 mx-auto text-center md:flex`}>
            <div>
              <Trans>Bạn đã có tài khoản ?</Trans>
            </div>
            <Link
              to={'/'}
              className={`text-luat_HN_primary hover:text-luat_HN_primary hover:underline cursor-pointer md:mt-0 mt-2 ml-0 md:ml-2`}
            >
              <Trans> Nhấn vào đây để đăng nhập</Trans>
            </Link>
          </div>
        </form>
      </div>
    </AuthLayout>
  );
}

export default ForgotPassWord
